<template>
  <div
    class="home"
    v-title
    data-title="卓考网校官网|1元题库|初级中级会计免费题库视频课程"
  >
    <header class="g-header-container">
      <c-header />
    </header>

    <main class="g-view-container">
      <home-banner class="home-banner" />

      <section class="section">
        <div class="section-headline">
          <p class="section-headline-text">课程试听</p>
          <router-link class="section-headline-more" to="/audit">
            查看更多 >
          </router-link>
        </div>
        <home-main-nav class="home-main-nav" />
      </section>

      <section class="section">
        <div class="section-headline">快速导航</div>
        <home-sub-nav class="home-sub-nav" />
      </section>

      <section class="section">
        <div class="section-headline">
          <p class="section-headline-text">卓考名师</p>
          <router-link class="section-headline-more" to="/teacher">
            查看更多 >
          </router-link>
        </div>
        <home-teacher class="home-teacher" />
      </section>

      <section class="section">
        <div class="section-headline">热点资讯</div>
        <home-news class="home-news" />
      </section>

      <section class="copyright">
        <p>©2021卓考网校</p>
        <div class="copyright-link">
          <a href="https://beian.miit.gov.cn/" target="_blank">豫ICP备18012350号-2</a>
          <a
            class="police"
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=41070202000982"
          >
            <img src="@/assets/img/police.png" />
            <p>豫公网安备 41070202000982号</p>
          </a>
        </div>
      </section>
    </main>

    <footer class="g-footer-container">
      <c-tabbar />
    </footer>
  </div>
</template>

<script>
  import CHeader from 'components/header';
  import CTabbar from 'components/tabbar';
  import HomeBanner from './banner';
  import HomeMainNav from './main-nav';
  import HomeSubNav from './sub-nav';
  import HomeTeacher from './teacher';
  import HomeNews from './news';

  export default {
    name: 'Home',
    components: {
      CHeader,
      HomeBanner,
      HomeMainNav,
      HomeSubNav,
      HomeTeacher,
      HomeNews,
      CTabbar,
    },
  };
</script>

<style lang="scss" scoped>
.g-header-container {
  margin-bottom: 5px;
}

.home-banner {
  margin-bottom: 10px;
}

.section {
  margin: 20px auto;
  width: 96%;
}

.section-headline {
  display: flex;
  align-items: baseline;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}

.section-headline-more {
  margin-left: auto;
  font-size: 12px;
  color: #999;
  font-weight: lighter;
}

.home-main-nav,
.home-sub-nav {
  background-color: #fff;
  border-radius: 6px;
}

.copyright {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #999;

  .copyright-link {
    display: flex;
    align-items: center;
    margin-top: 10px;
    a {
      color: #999;
    }

    .police {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-left: 10px;

      p {
        margin-left: 5px;
      }
    }
  }
}
</style>
